var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandSqueezing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.8016 50.8869C83.7797 50.3163 87.8791 56.1235 106.263 67.002C136.753 85.0742 144.287 80.1949 155.771 94.353C179.404 122.338 168.048 150.047 136.093 163.389C96.7915 179.973 53.0602 158.472 40.3624 114.665C37.8335 105.05 32.2859 84.029 44.5471 67.2153C47.8107 62.608 52.022 58.7632 56.8988 55.9422C61.7756 53.1266 67.2007 51.4042 72.8016 50.8869Z",
    fill: "#3E84C5",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.5698 32.6188C77.9454 31.8716 83.3136 39.476 107.387 53.7213C147.314 77.3866 157.179 70.9972 172.217 89.5369C203.164 126.184 188.294 162.467 146.449 179.938C94.9843 201.655 37.7187 173.5 21.0912 116.135C17.7797 103.545 10.5151 76.0179 26.571 54.0006C30.8446 47.9673 36.3592 42.9326 42.7453 39.2386C49.1314 35.5516 56.2356 33.2961 63.5698 32.6188Z",
    fill: "#3E84C5",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.0583 13.2798C73.1985 12.3889 79.599 21.4558 108.302 38.4405C155.907 66.6569 167.669 59.0387 185.599 81.1438C222.498 124.838 204.767 168.099 154.876 188.93C93.514 214.824 25.2358 181.254 5.41069 112.857C1.46229 97.8455 -7.19925 65.025 11.9442 38.7736C17.0398 31.58 23.6149 25.5771 31.2291 21.1727C38.8432 16.7767 47.3136 14.0874 56.0583 13.2798Z",
    fill: "#3E84C5",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_10414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3694 26.0788C80.6305 26.7876 77.3747 32.5933 71.3989 42.3959L85.317 84.1298L97.8103 96.3088L106.636 93.5854C102.891 73.9449 81.8905 60.4747 81.8905 60.4747C84.2543 56.3601 83.0503 50.1515 83.0503 50.1515C95.0579 34.7138 84.8578 22.7289 81.3665 26.0788H81.3694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3987 42.4077C71.3987 42.4077 62.9501 68.3715 63.2975 72.2685C63.6478 76.1654 68.0516 97.1647 79.6559 110.405C79.6559 110.405 67.0154 144.248 58.3284 164.124C57.8103 165.312 57.6572 166.636 57.9634 167.895C63.006 188.57 98.8963 194.153 110.733 187.129C112.067 186.338 113.029 185.044 113.433 183.55C119.411 161.471 120.754 129.196 122.205 127.278C123.7 125.308 133.874 109.608 138.566 96.9265C141.201 89.8061 140.568 80.8064 139.505 74.2802C142.025 68.8568 140.689 58.766 139.27 55.1661C137.763 51.3397 132.596 52.9073 132.596 52.9073C132.596 52.9073 133.047 51.7456 133.159 49.8957C133.271 48.0457 131.334 41.1018 127.671 39.4048C124.012 37.7078 121.125 38.9637 121.125 38.9637C121.125 38.9637 122.308 31.5875 118.042 28.1523C113.774 24.7142 107.792 27.7111 107.792 27.7111C107.792 27.7111 108.555 23.2995 108.246 21.0113C107.589 16.1909 102.29 13.5292 97.2272 15.6115C94.0067 16.9379 91.3279 22.6642 90.0474 28.564C89.02 29.8699 89.1201 35.7785 89.1201 35.7785",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.819 81.3534C131.466 81.3064 131.115 81.2387 130.777 81.1387C130.253 80.9858 129.826 80.8034 129.431 80.5799C129.37 80.5535 129.305 80.527 129.243 80.4976C128.804 80.3005 128.395 80.0594 128.004 79.78C127.221 79.3182 126.6 78.6947 126.137 77.9153C125.964 77.5006 125.787 77.0859 125.613 76.6742C125.434 76.1213 125.384 75.5448 125.434 74.9742C125.198 74.5037 125.01 74.0154 124.883 73.5184C121.736 74.5978 116.723 73.6978 114.377 71.5449C112.755 70.0567 112.896 67.3333 112.896 65.1716C112.896 63.6746 112.626 62.307 113.253 61.1365C112.443 61.1306 112.69 60.9365 112.652 60.9394C112.075 61.0688 112.637 61.4364 112.06 61.41C111.625 61.4835 111.183 61.5217 110.739 61.5217C107.536 61.5217 104.875 59.8277 103.338 57.3366C102.208 55.8425 101.516 53.9867 101.425 51.9985C101.416 51.7691 101.419 51.5427 101.428 51.3162C91.5071 54.9749 86.6558 54.772 82.561 56.5366C82.8318 57.2454 81.8133 57.6483 82.1047 58.4454C82.1695 58.6218 82.4756 59.0542 82.3991 59.1895C82.5816 59.7747 82.7641 60.3277 82.8377 60.9247C83.4971 61.6159 84.3832 62.1835 85.125 62.7423C87.1179 64.2481 89.0755 65.801 90.9654 67.4362C94.5127 70.5097 97.4652 73.9478 100.182 77.7947C104.033 83.2445 106.179 89.2238 106.938 95.6206C107.468 96.897 107.665 98.3323 107.804 99.7322C117.645 97.6676 127.238 91.3972 132.849 81.427C132.493 81.4299 132.151 81.4034 131.819 81.3505V81.3534Z",
    fill: "#4F95D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.757 101.367C104.71 73.6302 88.9668 65.954 83.4473 61.8512",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.471 61.86C82.2729 60.9718 81.7489 59.4424 82.1463 58.0071C83.2031 54.2073 82.3818 49.9486 82.3818 49.9486C83.1854 49.1957 84.3217 48.0016 85.3844 46.334C86.3882 44.7664 90.2946 38.1402 87.7129 31.1404C87.1713 29.6699 86.5236 26.9405 84.2216 25.77C83.9184 25.6171 83.5858 25.4847 83.3915 25.4376C80.1121 24.6553 73.1619 38.8519 71.5605 42.1694",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.298 26.9494C106.582 36.6079 102.661 44.5194 102.661 44.5194C102.373 45.887 95.1134 46.8369 91.9783 43.0576C88.8432 39.2784 88.9139 31.4316 91.2512 25.7082",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.664 44.5194C100.586 49.0074 100.648 55.8102 104.678 59.113C108.711 62.4158 112.693 61.7658 113.73 59.9865C113.73 59.9865 117.615 46.534 121.595 38.9784",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73 59.9865C112.319 65.8363 112.658 70.142 115.849 72.2273C119.04 74.3125 124.61 74.7889 125.719 72.392C125.719 72.392 130.479 62.6276 133.064 52.922",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9116 113.141C89.5262 122.784 104.101 119.017 104.101 119.017",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.708 121.399C113.662 128.131 121.966 127.07 121.966 127.07",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.187 73.139C124.577 78.8447 127.559 80.8828 131.351 81.2152C135.145 81.5475 138.94 75.183 139.579 73.6478",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1934 43.3635C78.7785 42.8636 80.6125 35.9285 80.6125 35.9285",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4841 42.0694C71.4841 42.0694 63.0356 68.0333 63.3829 71.9302C63.7332 75.8271 68.1371 96.8264 79.7414 110.067C79.7414 110.067 67.1009 143.91 58.4139 163.786C57.8958 164.974 57.7427 166.298 58.0488 167.556C63.0915 188.232 98.9817 193.814 110.819 186.791C112.152 186 113.115 184.706 113.518 183.212C119.497 161.133 120.839 128.858 122.29 126.94C123.786 124.97 133.959 109.27 138.652 96.5882C141.286 89.4679 140.653 80.4682 139.591 73.9419C142.111 68.5186 140.774 58.4277 139.355 54.8278C137.848 51.0015 132.982 53.3014 132.982 53.3014C132.982 53.3014 133.132 51.4074 133.244 49.5574C133.356 47.7075 131.419 40.7636 127.757 39.0666C124.098 37.3696 121.725 38.6696 121.725 38.6696C121.725 38.6696 122.393 31.2492 118.128 27.8111C113.859 24.373 108.122 27.4317 108.122 27.4317C108.122 27.4317 108.64 22.9583 108.328 20.6702C107.672 15.8497 102.373 13.1881 97.3097 15.2703C94.0892 16.5968 92.4731 19.9672 91.1926 25.87",
    stroke: "#50555A",
    strokeWidth: 1.02453,
    strokeMiterlimit: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.406 31.8746L145.233 40.3839",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9429 28.4915L57.688 41.4043",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7065 67.5425L51.0693 68.1483",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.298 69.3508L169.375 66.3399",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6099 6.2494L83.5823 20.3741",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.281 8.92946L123.367 24.3584",
    stroke: "#50555A",
    strokeLinecap: "round",
    strokeDasharray: "10 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_10414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 176,
    fill: "white",
    transform: "translate(57.4541 14.1145)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSqueezing);
export default __webpack_public_path__ + "static/media/hand_squeezing.82f5c9a1cb95dfceb7c726751e2ba82d.svg";
export { ForwardRef as ReactComponent };